<template>
  <div>
    <div id="multigrid-apply" style="display: flex; padding: 10px;">
      <SquareGrid style="--gutter: 10px">
        <div v-for="(img, index) in globalImages.uploadedImages" :key="img.id" class="image-grid-wrap uk-inline uk-box-shadow-medium uk-animation-fast uk-animation-slide-top-small">
          <!-- image buttons -->
          <div class="uk-text-muted grid-count">{{ index + 1 }}</div>
          <div class="uk-position-bottom-center uk-padding-small">
            <ul class="uk-iconnav">
              <li @click="refreshLightGallery(index)" class="uk-margin-small-left">
                <a class="uk-icon-button uk-icon"><i class="material-icons">zoom_in</i></a>
              </li>
              <li class="uk-margin-small-left">
                <a class="uk-icon-button uk-icon" @click="removeElement(index)"><i class="material-icons" style="font-size: 22px">delete_outline</i></a>
              </li>
            </ul>
          </div>
          <!-- image -->
          <div class="image-grid" @dblclick="refreshLightGallery(index)">  
            <div class="loading"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>
            <img v-if="img.dataURL.length > 0" class="uk-box-shadow-medium" :src="img.dataURL"/>
            <img v-else class="uk-box-shadow-medium" :src="img.thumbnailURL"/>
          </div>
        </div>
      </SquareGrid>   
    </div>
    <!-- Restart Button -->
    <div class="uk-text-center uk-text-small uk-padding-small">
      <button @click="$parent.$parent.restart()" class="uk-button uk-button-default uk-button-small uk-text-muted uk-text-capitalize" style="border-radius: 20px;"><i>Restart</i></button>
    </div>
  </div>
</template>



<script>
  // Import Components
  import UploadHandler from './UploadHandler.vue'

  // Lightgallery
  import 'lightgallery.js';
  import 'lg-thumbnail.js';
  import 'lg-zoom.js';
  import 'lg-share.js';

  export default {
    name: 'multigrid-apply',
    components: {
      'upload-handler': UploadHandler
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      removeElement: function (index) {
        var me;
        me = this;

        UIkit.modal.confirm('Removing <b>' + me.globalImages.uploadedImages[index].fileName + '</b> from export queue.'+ '<img width="200" style="display: block; margin: auto; padding: 10px 0 10px 0;" src="' + me.globalImages.uploadedImages[index].thumbnailURL + '"/><i style="font-size: 12px">Note: Order of images may change</i>')
          .then(function () {
            // when globalImages object is very large, splice is slow because it has to rewrite the entire array
            // splicing in reverse if the item is "earlier" speeds up the process
            if (me.globalImages.uploadedImages.length > 15) {
              let temp = me.globalImages.uploadedImages[index];
              me.globalImages.uploadedImages[index] = me.globalImages.uploadedImages.slice(-1)[0] 
              me.globalImages.uploadedImages.pop()
            } else {
              me.globalImages.uploadedImages.splice(index, 1);
            }
        }, function () {
        }); 
      },
      dblclickFullscreen: function(index) {
        var me;
        me = this;
        
        if (me.globalImages.uploadedImages[index].dataURL.length > 0) {
          var imgToDisplay = me.globalImages.uploadedImages[index].dataURL
        } else {
          var imgToDisplay = me.globalImages.uploadedImages[index].thumbnailURL
        }

        UIkit.lightboxPanel({
            items: [
                // with caption
                // {source: imgToDisplay, type: 'image', velocity: '100', caption: me.exifDetailsString(index)}
                // without caption (b/c it blocks watermarks at bottom of image)
                {source: imgToDisplay, type: 'image', velocity: '100'}
            ]
        }).show();
      },
      exifDetailsString: function(index) {
        return this.globalImages.uploadedImages[index].fileName + '  •  ' + 'f' + this.globalImages.uploadedImages[index].exif.FocalLengthIn35mmFilm + '  •  ' + 'ISO' + this.globalImages.uploadedImages[index].exif.ISOSpeedRatings
      },
      refreshLightGallery: function(index) {
        // lightgallery creates a new gallery every time it loads and persists the information in window.lgData
        // for this reason it needs to be cleared out upon making a new element.. this will iterate and create a new
        // window.lgData.uid that's associated to lg ('multigrid-apply') DOM element
        this.$nextTick(() => {
          try {
            var lg = document.getElementById('multigrid-apply');
            if (window.lgData) {
              window.lgData[lg.getAttribute('lg-uid')].destroy(true)
            }
          } catch (err) {
            console.warn(err)
          } finally {
            this.openLightGallery(index)
          }
        })
  
      },
      openLightGallery: function(index) {
      
      var imageList = [];      
      for (let n in this.globalImages.uploadedImages) {  
        imageList.push({'src': this.globalImages.uploadedImages[n].dataURL ?  this.globalImages.uploadedImages[n].dataURL : this.globalImages.uploadedImages[n].thumbnailURL, 'thumb':  this.globalImages.uploadedImages[n].dataURL ?  this.globalImages.uploadedImages[n].dataURL : this.globalImages.uploadedImages[n].thumbnailURL})
      }

      var imageIndex = index;
      var lg = document.getElementById('multigrid-apply');  

      lightGallery(lg, {
          dynamic: true,
          dynamicEl: imageList,
          destroy: true,
          index: imageIndex,
          thumbnail:false,
          progressBar: false,    
          zoom: true,
          mousewheel: true,
          fullScreen: false,
          hash: false 
      });   

      // lightgaller keeps its own data in window.. need to update imageIndex 
      // because reinstantiating lightgallery does not update index option :'(
      window.lgData[lg.getAttribute('lg-uid')].index = imageIndex


    },
     
    }
  }
</script>

<style scoped lang="scss">
  /* Multi-photo grid | responsive */
  .image-grid-wrap {
    padding: 5px;
    background-color: whitesmoke;
    border: 1px #c0c0c0 solid;
    border-radius: 4px;
  }

  .image-grid {
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    height: 100%;
    width: 100%;
  } 

  img {
    max-height: 100%;
    max-width: 100%;
    z-index: 1;    
  }

  .uk-position-bottom-center {
    z-index: 999;
  }

  .uk-lightbox-toolbar {
    background: rgba(0,0,0,.1);
  }

  .uk-box-shadow-medium {
    box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);
  }

  .grid-count {
    position: absolute; 
    font-weight: 200; 
    margin-top: -4px; 
    z-index:99;
  }

  .uk-icon-button {
    display: none;

    height: 30px;
    width: 30px;
    -webkit-box-shadow: 0 10px 15px -4px rgba(122, 122, 122, 0.7);
    -moz-box-shadow: 0 10px 15px -4px rgba(122, 122, 122, 0.7);
    box-shadow: 0 10px 15px -4px rgba(122, 122, 122, 0.7);     
  }

  .image-grid-wrap:hover .grid-count {
    font-weight: 400;
  }

  .image-grid-wrap:hover .uk-icon-button {
      display: inline-flex;
  }

  a:hover {
    text-decoration: none;
  }

  // This is the component code that comes with 3 variables for modification
  // SCSS below 

  SquareGrid{
    // The content width you use on your website
    --content-width: 75vw - var(--sidebar);
    
    // The size of the gutter  
    --gutter: 5px;
    
    // The size of the sidebar, .tm-sidebar-left
    --sidebar: 0px; 

    // The amount of columns
    --columns: 1;
    
    
    // This is the calculation for the row height.   
    --row-size: calc(
      ( var(--content-width) - (var(--gutter) * (var(--columns) - 1))) / var(--columns) 
    );
    
    display: grid;

    width: 100%;
    max-width: var(--content-width);
    
    grid-template-columns: repeat(var(--columns), 1fr);
    grid-auto-rows: var(--row-size);

    grid-column-gap: var(--gutter);
    grid-row-gap: var(--gutter);

  }


  // This is again demo. Just decide with media queries when to add another column 

  @media (min-width: 450px){
    SquareGrid{
      --columns: 2;
    }
  }

  @media (min-width: 750px){
    SquareGrid{
      --columns: 3;
    }
  }

  @media (min-width: 1200px){
    SquareGrid{
      --columns: 4;
    }
  }



.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}
.dot {
  width: 10px;
  height: 10px;
  border: 2px solid #11BB77;
  border-radius: 50%;
  float: left;
  margin: 0 5px;
  -webkit-transform: scale(0);
          transform: scale(0);
  -webkit-animation: fx 1000ms ease infinite 0ms;
          animation: fx 1000ms ease infinite 0ms;
}
.dot:nth-child(2) {
  -webkit-animation: fx 1000ms ease infinite 300ms;
          animation: fx 1000ms ease infinite 300ms;
}
.dot:nth-child(3) {
  -webkit-animation: fx 1000ms ease infinite 600ms;
          animation: fx 1000ms ease infinite 600ms;
}
@-webkit-keyframes fx {
  50% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fx {
  50% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>